module.exports = __webpack_public_path__ + "img/25_62.00cf7014.png";